import * as Accordion from "@radix-ui/react-accordion";
import classNames from "classnames";
import { CaretDown } from "components/icons/CaretDown";
import React, { ReactNode } from "react";
import { motion } from "framer-motion";

const Trigger = ({
  children,
  iconLeft = false,
  ...props
}: {
  children: ReactNode;
  iconLeft?: boolean;
} & Accordion.AccordionTriggerProps &
  React.RefAttributes<HTMLButtonElement>) => {
  const icon = !props.disabled && (
    <span
      className={classNames(
        "t-text-neutral t-transform t-transition t-duration-300 t-ease-in-out",
        iconLeft
          ? "group-data-state-open:t-rotate-0 group-data-state-closed:-t-rotate-90"
          : "group-data-state-open:-t-rotate-180 group-data-state-closed:t-rotate-0"
      )}
    >
      <CaretDown />
    </span>
  );

  return (
    <Accordion.Trigger asChild {...props}>
      <button
        className={classNames(
          "all:unset t-group t-select-none t-flex t-text-subtext sm:t-text-subtext-sm t-pb-5 t-gap-2 t-items-center t-border-l-surface-transparent",
          !iconLeft && "t-justify-between"
        )}
      >
        {iconLeft && icon}
        {children}
        {!iconLeft && icon}
      </button>
    </Accordion.Trigger>
  );
};

const Item = (
  props: Accordion.AccordionItemProps &
    React.RefAttributes<HTMLDivElement> & { isActive?: boolean }
) => {
  return (
    <Accordion.Item
      {...props}
      className={classNames(
        "t-flex t-flex-col t-gap-0 t-min-w-0",
        props.className || ""
      )}
    />
  );
};

const Content = (
  props: Accordion.AccordionContentProps & React.RefAttributes<HTMLDivElement>
) => {
  return (
    <Accordion.Content {...props} className={props.className || ""} asChild>
      <motion.div
        className="t-min-w-0"
        initial={{ y: -10, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
      >
        {props.children}
      </motion.div>
    </Accordion.Content>
  );
};

export const CheckListAccordion = {
  ...Accordion,
  Item,
  Trigger,
  Content,
};
